import "./Navbar.css";

function Navbar({ onWip }) {
  return (
    <nav className="navbar">
      <div className="nav-logo" style={{marginRight: 20}}>UrbanDel</div>

      {/* Hamburger toggle */}
      <input type="checkbox" id="nav-toggle" />
      <label htmlFor="nav-toggle" className="nav-toggle">☰</label>

      <ul className="nav-links">
        <li>
          <button onClick={onWip}>
            🏠 Home
          </button>
        </li>
        <li>
          <button onClick={onWip}>
            📦 Products
          </button>
        </li>
        <li>
          <button onClick={onWip}>
            🛍️ Shop Now
          </button>
        </li>
        <li className="cart">
          <button onClick={onWip}>
            🛒 Cart
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
